import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef } from 'vue';
import { UserModel, LevelModel, RoleModel } from '@/types';
import { useAuthStore } from '@/stores';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfilePage',
  setup(__props, { expose: __expose }) {
  __expose();

const authStore = useAuthStore();
const user: ComputedRef<UserModel | undefined> = computed(() => authStore.userModel);

const userLevels = computed(() =>
    authStore.userLevels.map((level: LevelModel) => level.id + ':' + level.name),
);
const userRoles = computed(() =>
    authStore.userRoles.map((role: RoleModel) => role.id + ':' + role.name),
);
const userPermissions = computed(() => authStore.userPermissions);

const __returned__ = { authStore, user, userLevels, userRoles, userPermissions }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})